import React from 'react';
import { Outlet } from '@tanstack/react-router';

export const withModalOutlet = (Component: React.ComponentType) => () => (
  <>
    <Component />
    <Outlet />
  </>
);
